export default __webpack_public_path__ + "static/media/angle-right.d1d20bd6.svg";